import { Center, Group, Loader, Paper, Radio, Stack, Text } from '@mantine/core';

import { useTestTemplates } from '@admin/hooks';
import { BatchSearchCard } from './BatchSearchCard';

interface TemplateSelectionStepProps {
  selectedTemplate: string;
  onTemplateChange: (template: string) => void;
  onBatchSelected: (batchId: string) => void;
}

export const TemplateSelectionStep = ({ selectedTemplate, onTemplateChange, onBatchSelected }: TemplateSelectionStepProps) => {
  const { data: templatesData, isLoading: isLoadingTemplates } = useTestTemplates();

  return (
    <Stack gap="md" mt="md">
      <Text size="sm" c="dimmed">
        Select an integration test template to define how requests will be grouped and formatted
      </Text>

      {isLoadingTemplates ? (
        <Center p="xl">
          <Loader size="md" />
        </Center>
      ) : (
        <Radio.Group value={selectedTemplate} onChange={onTemplateChange}>
          <Stack gap="sm">
            {templatesData?.templates.map((template) => (
              <Paper key={template.id} shadow="xs" p="md" withBorder style={{ cursor: 'pointer' }} onClick={() => onTemplateChange(template.id)}>
                <Group justify="space-between">
                  <Stack gap="xs" style={{ flex: 1 }}>
                    <Group>
                      <Radio value={template.id} label="" />
                      <Text fw={500}>{template.name}</Text>
                    </Group>
                    <Text size="sm" c="dimmed" pl={32}>
                      {template.description}
                    </Text>
                  </Stack>
                </Group>
              </Paper>
            ))}
          </Stack>
        </Radio.Group>
      )}

      <BatchSearchCard onBatchSelected={onBatchSelected} />
    </Stack>
  );
};
